import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://xoxvlouxkefaglzdxhez.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhveHZsb3V4a2VmYWdsemR4aGV6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3OTY2MTUsImV4cCI6MjA2ODM3MjYxNX0.R5rp7ubCaWmrXHJFhTSx09GbQmNkRC4Tfbuou9TH3vU'

// Configure client with persistent sessions and proper initialization
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storageKey: 'supabase.auth.token',
    // Increase refresh threshold to avoid frequent token refreshes
    autoRefreshThreshold: 600,
  },
  global: {
    headers: {
      'x-application-name': 'backlink-discovery'
    },
    fetch: (url, options) => {
      return fetch(url, {
        ...options,
        // Add timeout to prevent hanging requests
        signal: AbortSignal.timeout(30000),
      });
    },
  },
  // Initialize auth on client creation to avoid race conditions
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
})

// Preload the auth session to reduce initial load flashes
supabase.auth.getSession().catch(console.error)